import React from "react";
import "./App.css";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { MarqueeBar } from "./components/MarqueeBar";
import { About } from "./components/About";
import { Roadmap } from "./components/Roadmap";
import { Phase1Details } from "./components/Phase1Details";
import { HowToBuy } from "./components/HowToBuy";
import { Footer } from "./components/Footer";

function App() {
    return (
        <div className="App grain min-h-screen">
            <Nav />
            <main>
                <Hero />
                <MarqueeBar variant="pink" />
                <About />
                <MarqueeBar variant="yellow" />
                <Roadmap />
                <Phase1Details />
                <HowToBuy />
                <Footer />
            </main>
        </div>
    );
}

export default App;
